import { Section, Session } from "@models/ISchema";
import { Week } from "@modules/sections/ISections";
import orderSessionsByWeeks from "../utils/orderSessionsByWeeks";
import sessionAdapter from "./session";

/**
 * Given a raw `Section`, return a new `Section` with:
 * - sessions and unasignedSessions as `editedSessions`.
 * - the weeks of all the sessions ordered by weeks.
 *
 * @param linkWeeks - Week[]
 * @param section - Section
 * @return Section
 */
const sectionAdapter =
  (linkWeeks: Week[]) =>
  (section: Section): Section => ({
    ...section,
    sessions: orderSessionsByWeeks(
      section.sessions.map(sessionAdapter(linkWeeks)),
    ) as unknown as Session[],
    unasignedSessions: orderSessionsByWeeks(
      section.unasignedSessions.map(sessionAdapter(linkWeeks)),
    ) as unknown as Session[],
  });

export default sectionAdapter;
